import { Paginacao } from "@/types/paginacao";
import { LicitacaoVencedorItem } from "../licitacao-vencedor-item";

export class RetornoBuscarVencedoresItem extends Paginacao {
  DtAdjudicacao: Date;
  DtHomologacao: Date;
  FlHomologParcial: string;
  licitacaoVlTotalLicitado: number;
  licitacaoVlTotalEstimado: number;
  itensComVencedores: LicitacaoVencedorItem[];

  montarObjeto(data: any): void {
    if (data.DtAdjudicacao) this.DtAdjudicacao = new Date(data.DtAdjudicacao);
    if (data.DtHomologacao) this.DtHomologacao = new Date(data.DtHomologacao);
    if (data.FlHomologParcial)
      this.FlHomologParcial = data.FlHomologParcial === "S" ? "Sim" : "Não";

    this.page = data.page;
    this.pageSize = data.pageSize;
    this.totalRows = data.totalRows;
    this.licitacaoVlTotalLicitado = data.licitacaoVlTotalLicitado;
    this.licitacaoVlTotalEstimado = data.licitacaoVlTotalEstimado;
    this.itensComVencedores = data.itens.map((v) => {
      const vencedor = Object.assign(new LicitacaoVencedorItem(), v);
      vencedor.tratarDadosDaAPI();
      return vencedor;
    });
  }
}
